import React from "react";
import PieCharts from "./PieCharts";

const DonutCharts = ({
  series = [],
  categories = [],
  options = {},
  height = "100%",
  width = "100%",
}) => {
  return (
    <PieCharts
      series={series}
      categories={categories}
      options={options}
      height={height}
      width={width}
      donut={true}
    />
  );
};

export default DonutCharts;
